import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const AbvPipeDayList = ({ pipeDayGrpId }) => {

  const augRowsReq = useCallback((rowsReq) => {
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('pipeDayGrpId', pipeDayGrpId));
    }, [pipeDayGrpId]);
  
  return (
    <EntityList entity="PIPE_DAY" augRowsReq={augRowsReq} />
  )
}